"use client";

import { clsx } from "@frend-digital/ui";
import { useId, type ComponentProps } from "react";
import { useFormContext } from "react-hook-form";
import styles from "./checkbox.module.css";

export interface CheckboxProps extends ComponentProps<"input"> {
  label?: React.ReactNode;
  error?: string | boolean;
  success?: string | boolean;
  noBorder?: boolean;
  name: string;
}

export const FormCheckbox = ({
  className,
  error,
  success,
  label,
  id: initialId,
  onChange,
  noBorder = false,
  value,
  name,
  required,
  ...props
}: CheckboxProps) => {
  const { register } = useFormContext();

  const internalId = useId();
  const id = initialId ?? internalId;

  return (
    <div className={clsx(styles.checkboxWrapper, className)}>
      <label
        className={clsx(
          styles.label,
          error && styles.error,
          success && styles.success,
          required && styles.required
        )}
        htmlFor={id}
      >
        <div data-hide-border={noBorder} className={styles.checkbox}>
          <input
            type="checkbox"
            id={id}
            value={value}
            readOnly
            className={clsx(styles.input)}
            aria-invalid={!!error}
            {...register(name)}
            {...props}
          />
        </div>
        {label && <span className={styles.labelText}>{label}</span>}
      </label>
      {error && typeof error === "string" && (
        <span className={clsx(styles.statusText, styles.errorText)}>
          {error}
        </span>
      )}
      {success && typeof success === "string" && (
        <span className={clsx(styles.statusText, styles.successText)}>
          {success}
        </span>
      )}
    </div>
  );
};
